import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { useTheme, alpha } from '@mui/material/styles';
import { Box } from '@mui/material';
//
import Logo from './Logo';

// ----------------------------------------------------------------------

LogoLoader.propTypes = {
    size: PropTypes.number,
    sx: PropTypes.object,
};

export default function LogoLoader({ size = 100, sx, ...other }) {
    const theme = useTheme();

    // Circle properties for spinner ring
    const strokeWidth = 4.5;
    const radius = 50 - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                width: size,
                height: size,
                ...sx,
            }}
            {...other}
        >
            {/* Centered Pulsing Logo */}
            <Box
                component={m.div}
                animate={{
                    scale: [0.92, 1.05, 0.92],
                    opacity: [0.85, 1, 0.85]
                }}
                transition={{
                    duration: 2,
                    ease: "easeInOut",
                    repeat: Infinity
                }}
                sx={{
                    position: 'absolute',
                    zIndex: 9,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Logo
                    disabledLink
                    sx={{
                        width: size * 0.72,
                        height: size * 0.72,
                        padding: 0,
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    }}
                />
            </Box>

            {/* Glowing Rotating Ring */}
            <Box
                component={m.svg}
                viewBox="0 0 100 100"
                animate={{ rotate: 360 }}
                transition={{
                    duration: 1.2,
                    ease: "linear",
                    repeat: Infinity
                }}
                sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    filter: `drop-shadow(0 0 8px ${alpha(theme.palette.primary.main, 0.8)}) drop-shadow(0 0 3px ${alpha(theme.palette.primary.light, 0.5)})`
                }}
            >
                {/* Background track (faint) */}
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="none"
                    stroke={theme.palette.primary.main}
                    strokeOpacity={0.12}
                    strokeWidth={strokeWidth}
                />

                {/* Glowing tail */}
                <m.circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="none"
                    stroke={theme.palette.primary.main}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    initial={{ strokeDashoffset: circumference }}
                    animate={{ strokeDashoffset: [circumference * 0.85, circumference * 0.25, circumference * 0.85] }}
                    transition={{
                        duration: 1.8,
                        ease: "easeInOut",
                        repeat: Infinity
                    }}
                />
            </Box>
        </Box>
    );
}
